
// utils/formatDate.js
export const formatDate = (dateString) => {
  if (!dateString) return "";

  let s = String(dateString).trim();
  if (!s) return "";

  // ✅ Case 0: Already formatted like "10 Feb, 2026"
  if (/^\d{1,2}\s[A-Za-z]{3},?\s\d{4}$/.test(s)) {
    return s.replace(",", "").toUpperCase();
  }

  // Remove microseconds and trailing Z
  s = s.replace(/\.\d+/, "").replace(/Z$/, "");

  let day, month, year;

  // ✅ Case 1: DD-MM-YYYY or DD/MM/YYYY
  if (/^\d{2}[-/]\d{2}[-/]\d{4}$/.test(s)) {
    const parts = s.includes("-") ? s.split("-") : s.split("/");
    day = parts[0];
    month = parts[1];
    year = parts[2];
  }
  // ✅ Case 2: ISO or YYYY-MM-DD
  else {
    if (!s.includes("T")) s = `${s}T00:00:00`;
    const d = new Date(s);
    if (isNaN(d.getTime())) return s; // return original instead of blank
    day = String(d.getDate()).padStart(2, "0");
    month = String(d.getMonth() + 1).padStart(2, "0");
    year = d.getFullYear();
  }

  const monthShort = new Date(`${year}-${month}-${day}`)
    .toLocaleString("en-GB", { month: "short" })
    .toUpperCase();

  return `${day} ${monthShort} ${year}`;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "";

  // Append Z if no timezone info so browser treats it as UTC → converts to IST
  const normalized =
    dateString.endsWith("Z") || dateString.includes("+")
      ? dateString
      : dateString + "Z";

  const d = new Date(normalized);
  if (isNaN(d.getTime())) return dateString;

  const day = String(d.getDate()).padStart(2, "0");
  const month = d.toLocaleString("en-GB", { month: "short" }).toUpperCase();
  const year = d.getFullYear();

  const time = d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).toUpperCase();

  return `${day} ${month} ${year} ${time}`;
};

// Excel Date Helper
export const setExcelDateCell = (
  cell,
  value,
  format = "dd-mmm-yyyy"
) => {
  if (!value) {
    cell.value = "";
    return;
  }

  try {
    const date =
      value instanceof Date
        ? value
        : new Date(
            /^\d{4}-\d{2}-\d{2}$/.test(String(value))
              ? `${value}T00:00:00`
              : value
          );

    if (isNaN(date.getTime())) {
      cell.value = "";
      return;
    }

    cell.value = date;      // Real Excel Date
    cell.numFmt = format;   // Excel Date Format
  } catch {
    cell.value = "";
  }
};



export default formatDate;



